import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

/**
 * Resizing text field component
 */
@Component({
  selector: 'pollux-report-designer-resizing-text-field',
  templateUrl: './pollux-report-designer-resizing-text-field.component.html'
})
export class PolluxReportDesignerResizingTextFieldComponent {
  /**
   * The text area element
   */
  @ViewChild(HTMLTextAreaElement) textArea: HTMLTextAreaElement;

  /**
   * Maximum length
   */
  @Input() ngMaxLength: number;

  /**
   * Minimum length
   */
  @Input() ngReadonly: boolean;

  /**
   * ID for HTML
   */
  @Input() ngId: any;

  /**
   * ng-model
   */
  @Input() ngModel: number;

  /**
   * ng-model change listener
   */
  @Output() ngModelChange: EventEmitter<number> = new EventEmitter<number>();

  /**
  * ng-model change listener
  */
  @Output() ngChange: EventEmitter<number> = new EventEmitter<number>();

  /**
   * Change handler
   */
  public onNgChange(): void {
    try {
      this.textArea.style.height = '1px';
      const height = this.textArea.scrollHeight;
      this.textArea.style.height = height + 'px';
    } catch (e) {
      //Nothing
    }
    this.ngChange.next(this.ngModel);
    this.ngModelChange.next(this.ngModel);
  }
}
